import { Dispatch } from 'redux';

import { setPageNumber } from '@/store/redux/actions/pages/pcp';

import {
  IReduxActionProps,
  IReduxPayloadProps,
} from '../../../../../Utils/index';

export const SET_FILTER_BODY_COLORS = 'SET_FILTER_BODY_COLORS';
export const DELETE_FILTER_BODY_COLORS = 'DELETE_FILTER_BODY_COLORS';
export const RESET_FILTER_BODY_COLORS = 'RESET_FILTER_BODY_COLORS';

export const setFilterBodyColors = ({ colors }: IReduxPayloadProps) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: SET_FILTER_BODY_COLORS,
      payload: { colors },
    });
  };
};

export const deleteFilterBodyColors = ({ color }: IReduxPayloadProps) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: DELETE_FILTER_BODY_COLORS,
      payload: { color },
    });
  };
};

export const resetFilterBodyColors = (): IReduxActionProps => {
  return {
    type: RESET_FILTER_BODY_COLORS,
  };
};
